module.exports = __webpack_public_path__ + "img/pay_method.9a856984.svg";